export default function AboutUs() {
  return (
    <section className="w-full py-8 md:py-12 bg-muted/30">
      <div className="container px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <img
              src="/about-us.jpg"
              alt="Zdeno Cycle - Authentically Motorcycle Since 1969"
              className="w-full h-auto rounded-lg shadow-md object-cover"
            />
          </div>

          {/* Text */}
          <div className="space-y-4">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground">
              Authentically Motorcycle since 1969.
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              For over five decades, Zdeno has been at the heart of Canada's motorcycle culture—built by riders, for riders. "Authentically Motorcycle Since 1969" isn't just a tagline; it's a reflection of our roots, our values, and our unwavering commitment to the community. Servicing bikes and selling gear from vintage restorations to modern performance, from weekend warriors to lifelong builders, we've always stood for passion, craftsmanship, and connection. Today, that legacy continues with new energy, new faces, and the same love for the ride that started it all.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
